"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var TabControls_styles_1 = __importDefault(require("./TabControls.styles"));
var TabControls = function (_a) {
    var active = _a.active;
    return (react_1.default.createElement(TabControls_styles_1.default, null,
        react_1.default.createElement("div", { className: "tab-controls__wrapper" },
            react_1.default.createElement("div", { className: "tab-controls__inner" },
                react_1.default.createElement("p", { className: classnames_1.default('tab-controls__item', active === 1 && 'active', active === 2 && 'completed') },
                    active === 1 && react_1.default.createElement("span", null, "1.\u00A0"),
                    active === 2 && (react_1.default.createElement("img", { className: "icon icon--checkmark", src: "/dist/assets/img/checkmark.png", "aria-hidden": "true" })),
                    "Beschikbaarheid"),
                react_1.default.createElement("p", { className: classnames_1.default('tab-controls__item', active === 2 && 'active') }, "2. Clinic specifiek")))));
};
exports.default = TabControls;
